import { Formik, FormikHelpers } from 'formik'
import { ReactNode } from 'react'
import { ObjectSchema } from 'yup'
import { Assign, ObjectShape } from 'yup/lib/object'

interface iValidatedFormProps{
    children: ReactNode
    initialValues: Record< string | number | symbol, any>
    onSubmit: (values: any, formikHelepers: FormikHelpers<any>)=>void | Promise<any>
    validationSchema: ObjectSchema<Assign<ObjectShape, any>>
}

export default function ValidatedForm({children, initialValues, onSubmit, validationSchema}:iValidatedFormProps) {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, formikHelpers)=>onSubmit(values, formikHelpers)}
        >

                {children}

        </Formik>
    )
}
